import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useCurrentUser, useAccessToken } from '@/features/auth/state/auth'

import axios from 'axios'
import { RemovaCharEspeciais } from '@/utils/format'

// Cria uma instância do axios com a URL base da API definida no arquivo .env
const BASE_URL = import.meta.env.VITE_API_BASE_URL
const api = axios.create({ baseURL: BASE_URL })

// Hook para buscar todos os Tenants
export function useFetchIdTenants() {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useQuery({
    queryKey: ['tenants'],
    queryFn: async () => {
      if (!user || !token) throw new Error('Usuário ou token ausente')

      const response = await api.get('/tenants', {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data && Array.isArray(response.data.data)) {
        return response.data.data
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    },
    enabled: Boolean(user && token)
  })
}
export function useFetchByCnpjTenants(cnpj: string) {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useQuery({
    queryKey: ['tenants', cnpj],
    queryFn: async () => {
      if (!user || !token) throw new Error('Usuário ou token ausente')

      const response = await api.get(`/tenants/find-by-cnpj/${cnpj}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (response.data && response.data.data) {
        return response.data.data
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    },
    enabled: Boolean(user && token)
  })
}

export function useFetchIdTenantsPermissions(typeUser: string | undefined) {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useQuery({
    queryKey: ['tenants', typeUser],
    queryFn: async () => {
      if (!user || !token) throw new Error('Usuário ou token ausente')
      if (typeUser == 'ADMIN') {
        const response = await api.get('/tenants/permissions', {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (response.data && Array.isArray(response.data.data)) {
          return response.data.data
        } else {
          throw new Error('Nenhum dado encontrado')
        }
      }
      return []
    },
    enabled: Boolean(user && token)
  })
}

export function useCreateTenant() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({
      cnpj_data,
      info_tenant,
      Regime_produto
    }: {
      cnpj_data: any
      info_tenant: any
      Regime_produto: any
    }) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        cnpj: RemovaCharEspeciais(cnpj_data.cnpj),
        fantasia: cnpj_data.fantasia,
        razao_social: cnpj_data.razao_social,
        cnae: cnpj_data.cnae,
        cnae_info: cnpj_data.cnae_info,
        email: info_tenant.email,
        whatsApp: info_tenant.whatsapp,
        comissao_admin: Regime_produto.comissao,
        logradouro: cnpj_data.logradouro,
        bairro: cnpj_data.bairro,
        numero: cnpj_data.numero,
        cidade: cnpj_data.cidade,
        uf: cnpj_data.uf,
        complemento: cnpj_data.complemento,
        tipo: cnpj_data.tipo,

        cep: cnpj_data.cep
      }

      try {
        const response = await api.post(`/tenants/create-tenant`, body, {
          headers: { Authorization: `Bearer ${token}` }
        })

        if (response.data) {
          return response.data
        } else {
          throw new Error('Erro ao criar cliente')
        }
      } catch (error: any) {
        console.error('Server response error:', error.response?.data || error.message)
        throw new Error(error.response?.data.message || 'Erro ao criar cliente')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tenants'] })
    }
  })
}
